/** Legal notes */
export const TERMS_OF_SERVICE_URL = 'https://paradex.trade/terms-of-service';
/** Legal notes */
export const PRIVACY_POLICY_URL = 'https://www.paradex.trade/privacy-policy';
/** Legal notes */
export const ABOUT_RESTRICTED_PERSONS_URL =
  'https://paradex.trade/restricted-persons';
/** Paradex product docs site */
export const PRODUCT_DOCS_URL = 'https://docs.paradex.trade/';
/** Paradex statistics */
export const STATS_URL =
  'https://tradeparadigm.metabaseapp.com/public/dashboard/e4d7b84d-f95f-48eb-b7a6-141b3dcef4e2';
/** Paradex Discord server */
export const DISCORD_URL = 'https://discord.gg/paradex';
/** URL to Paradex github code samples */
export const CODE_SAMPLES_URL = 'https://github.com/tradeparadex';
/** URL to Paradex twitter user */
export const TWITTER_URL = 'https://twitter.com/tradeparadex';
/** URL to Paradex youtube channel */
export const YOUTUBE_URL = 'https://www.youtube.com/tradeparadigm';
/** URL to documentation explaining how deleverage works */
export const DELEVERAGE_DOCS_URL =
  'https://docs.paradex.trade/risk-system/deleveraging';
/** URL to documentation explaining health checks */
export const UNHEALTHY_DOCS_URL =
  'https://docs.paradex.trade/risk-system/paradex-risk-checks#health-check';
/** URL to documentation explaining liquidation */
export const LIQUIDATION_DOCS_URL =
  'https://docs.paradex.trade/risk-system/liquidations';
/** URL to documentation explaining deposit / withdrawal */
export const DEPOSITS_WITHDRAWALS_DOCS_URL =
  'https://docs.paradex.trade/deposits-and-withdrawals/overview';
